import { render, staticRenderFns } from "./PieTable.vue?vue&type=template&id=ff29e4f8&scoped=true&"
import script from "./PieTable.vue?vue&type=script&lang=js&"
export * from "./PieTable.vue?vue&type=script&lang=js&"
import style0 from "./PieTable.vue?vue&type=style&index=0&id=ff29e4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff29e4f8",
  null
  
)

export default component.exports